
import React, { useState } from "react";
import axios from "axios";
import "./EnrollForm.css";

const EnrollForm = ({ course, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    course: course?.title || "", // use title here
    address: "",
    agree: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.agree) {
      alert("⚠️ You must agree to the terms and conditions before submitting.");
      return;
    }

    try {
      await axios.post(process.env.REACT_APP_API_URL+"/api/enrollments", formData);
      alert("✅ Enrollment submitted successfully!");
      onClose();
    } catch (err) {
      console.error("Error submitting enrollment:", err);
      alert("❌ Failed to submit enrollment. Please try again.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {/* ❌ Cancel button */}
        <button type="button" className="cancel-btn" onClick={onClose}></button>

        {/* 🖼 Course Image */}
        {course?.image && (
          <div className="course-image-popup">
            <img
              src={process.env.REACT_APP_API_URL+`${course.image}`}
              alt={course.title}
            />
          </div>
        )}

        {/* Title */}
        <h2>Enroll in {course?.title}</h2>

        {/* Form */}
        <form onSubmit={handleSubmit} className="enroll-form">
          <label>
            Name:
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Email:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Phone:
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Chosen Course:
            <input type="text" name="course" value={formData.course} readOnly />
          </label>

          <label>
            Address:
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </label>

          <label className="terms-checkbox">
            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
              required
            />
            I agree to the terms and conditions and confirm that I am above 18 years of age capable of entering into a valid contract under the laws of India.
          </label>

          {/* ✅ Submit button */}
          <div className="form-actions">
            <button type="submit" className="submit-btn">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EnrollForm;
